var cov_1y3bjgc6e = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Icon/index.tsx",
      hash = "08b24582943a85bc0c6057530ba6f734335dc17e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Icon/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 6
        }
      },
      "1": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 6
        }
      },
      "2": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "3": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 71
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 66
        }
      },
      "5": {
        start: {
          line: 21,
          column: 14
        },
        end: {
          line: 21,
          column: 50
        }
      },
      "6": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "7": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 21
        }
      },
      "8": {
        start: {
          line: 24,
          column: 17
        },
        end: {
          line: 24,
          column: 47
        }
      },
      "9": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 42
        }
      },
      "10": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 41
        }
      },
      "11": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 34
        }
      },
      "12": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 35
        }
      },
      "13": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 35,
          column: 3
        }
      },
      "14": {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 31,
          column: 51
        }
      },
      "15": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 25
        }
      },
      "16": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 35
        }
      },
      "17": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 37
        }
      },
      "18": {
        start: {
          line: 37,
          column: 22
        },
        end: {
          line: 37,
          column: 117
        }
      },
      "19": {
        start: {
          line: 37,
          column: 48
        },
        end: {
          line: 37,
          column: 117
        }
      },
      "20": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 35
        }
      },
      "21": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 20
        }
      }
    },
    fnMap: {
      "0": {
        name: "icon",
        decl: {
          start: {
            line: 12,
            column: 24
          },
          end: {
            line: 12,
            column: 28
          }
        },
        loc: {
          start: {
            line: 16,
            column: 38
          },
          end: {
            line: 40,
            column: 1
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 22
          },
          end: {
            line: 37,
            column: 23
          }
        },
        loc: {
          start: {
            line: 37,
            column: 48
          },
          end: {
            line: 37,
            column: 117
          }
        },
        line: 37
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 15
          },
          end: {
            line: 14,
            column: 25
          }
        }],
        line: 14
      },
      "1": {
        loc: {
          start: {
            line: 15,
            column: 2
          },
          end: {
            line: 15,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 15,
            column: 11
          },
          end: {
            line: 15,
            column: 17
          }
        }],
        line: 15
      },
      "2": {
        loc: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        }, {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        }],
        line: 17
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }, {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 19
          }
        }, {
          start: {
            line: 22,
            column: 23
          },
          end: {
            line: 22,
            column: 34
          }
        }],
        line: 22
      },
      "5": {
        loc: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }, {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 35,
            column: 3
          }
        }],
        line: 30
      },
      "6": {
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 30,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 30,
            column: 18
          }
        }, {
          start: {
            line: 30,
            column: 22
          },
          end: {
            line: 30,
            column: 35
          }
        }],
        line: 30
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Icon/index.tsx";
import React from 'react';
import Icon from './Icon';
var links = (cov_1y3bjgc6e.s[0]++, {});
var scripts = (cov_1y3bjgc6e.s[1]++, {});
export default function icon(url) {
  var _this = this;

  var fontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1y3bjgc6e.b[0][0]++, 'iconfont');
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_1y3bjgc6e.b[1][0]++, 'icon');
  cov_1y3bjgc6e.f[0]++;
  cov_1y3bjgc6e.s[2]++;

  if (typeof url !== 'string') {
    cov_1y3bjgc6e.b[2][0]++;
    cov_1y3bjgc6e.s[3]++;
    console.error("Shineout Icon url must be a string, but get ".concat(url));
    cov_1y3bjgc6e.s[4]++;
    return null;
  } else {
    cov_1y3bjgc6e.b[2][1]++;
  }

  var ext = (cov_1y3bjgc6e.s[5]++, url.substr(url.lastIndexOf('.') + 1));
  cov_1y3bjgc6e.s[6]++;

  if ((cov_1y3bjgc6e.b[4][0]++, ext === 'css') && (cov_1y3bjgc6e.b[4][1]++, !links[url])) {
    cov_1y3bjgc6e.b[3][0]++;
    cov_1y3bjgc6e.s[7]++;
    links[url] = true;
    var link = (cov_1y3bjgc6e.s[8]++, document.createElement('link'));
    cov_1y3bjgc6e.s[9]++;
    link.setAttribute('rel', 'stylesheet');
    cov_1y3bjgc6e.s[10]++;
    link.setAttribute('type', 'text/css');
    cov_1y3bjgc6e.s[11]++;
    link.setAttribute('href', url);
    cov_1y3bjgc6e.s[12]++;
    document.head.appendChild(link);
  } else {
    cov_1y3bjgc6e.b[3][1]++;
  }

  cov_1y3bjgc6e.s[13]++;

  if ((cov_1y3bjgc6e.b[6][0]++, ext === 'js') && (cov_1y3bjgc6e.b[6][1]++, !scripts[url])) {
    cov_1y3bjgc6e.b[5][0]++;
    var script = (cov_1y3bjgc6e.s[14]++, document.createElement('script'));
    cov_1y3bjgc6e.s[15]++;
    scripts[url] = script;
    cov_1y3bjgc6e.s[16]++;
    script.setAttribute('src', url);
    cov_1y3bjgc6e.s[17]++;
    document.body.appendChild(script);
  } else {
    cov_1y3bjgc6e.b[5][1]++;
  }

  cov_1y3bjgc6e.s[18]++;

  var wrapperIcon = function wrapperIcon(props) {
    cov_1y3bjgc6e.f[1]++;
    cov_1y3bjgc6e.s[19]++;
    return (
      /*#__PURE__*/
      React.createElement(Icon, Object.assign({
        ext: ext,
        fontFamily: fontFamily,
        prefix: prefix
      }, props, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37,
          columnNumber: 49
        }
      }))
    );
  };

  cov_1y3bjgc6e.s[20]++;
  wrapperIcon.isShineoutIcon = true;
  cov_1y3bjgc6e.s[21]++;
  return wrapperIcon;
}